import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";

export class FRCondE extends FRBase{
    public Cond:FRBase;
    public Tr:FRBase;
    public Fa:FRBase;
    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);

        this.Cond=FRFactory.GetFRElement(Options.C,this);
        this.Tr=FRFactory.GetFRElement(Options.Tr,this);
        this.Fa=FRFactory.GetFRElement(Options.Fa,this);
    }

    Parse(): any {
        return this.MaybeExecutePromise(this.Cond.Parse(),result=>{
            if(result)
                return this.MaybeExecutePromise(this.Tr.Parse(),result=>result);
            else
                return this.MaybeExecutePromise(this.Fa.Parse(),result=>result);
        })
    }

}

FRFactory.AddField('CE',FRCondE);